import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntTypeProduct } from "../../../../models/handBooks/typeProduct";
import { useAddProductTypeMutation, useDeleteProductTypeMutation, useEditProductTypeMutation } from "../../../../redux/api/handBooksApi/productTypesApi";
import { getCookie } from "typescript-cookie";

const useTypeProduct = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addTypeProduct] = useAddProductTypeMutation();
    const [deleteTypeProduct] = useDeleteProductTypeMutation();
    const [editTypeProduct] = useEditProductTypeMutation();
    async function onAddTypeProduct(newTypeProduct: EntTypeProduct): Promise<boolean> {
        try {
            let status: boolean = false;
            await addTypeProduct(newTypeProduct).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error:any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
          
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }
    async function onDeleteTypeProduct(typeProduct: EntTypeProduct) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteTypeProduct(typeProduct.id).then((response: any) => {
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({title: t('msg.successDelete')});
                            if(refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                        
                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    };
    async function onEditTypeProduct(editedTypeProduct: EntTypeProduct): Promise<boolean> {
        try {
            let status: boolean = false;
            await editTypeProduct(editedTypeProduct).then((response: any) => {
                   if (response.error) {
                                               const isKyrgyz = getCookie('i18next') === 'ky';
                                               const lang = isKyrgyz ? 'kg' : 'ru';
                                               const res = response.error.data?.res;
                                               const errorMessages = Array.isArray(res)
                                                   ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                   : response.error.data?.msg || t('unknownError'); 
                                               throw new Error(errorMessages);
                                           }
                if (response.data.success) {
                    status = true;
                    Modal.success({title: t('msg.successEdited')});
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    };
    return { onAddTypeProduct,onDeleteTypeProduct, onEditTypeProduct }

}
export { useTypeProduct };

